module.exports = __webpack_public_path__ + "img/logo2.c0338467.svg";